import * as yup from 'yup';

import i18n from '@app/i18n/config';

import { firstNameSchema, lastNameSchema } from '@entities/fio-fields/model';

import { onlyCyrillic, onlyLetters } from '@shared/regexps';

import type { OldFioDetails } from '../../../api';
import { RECORDS_PER_FORM_MAX, RECORDS_PER_FORM_MIN } from '../../constants';

const middleNameSchema = yup
  .string()
  .max(50, i18n.t('COMMON:errors.maxLength'))
  .matches(onlyLetters, {
    excludeEmptyString: true,
    message: i18n.t('COMMON:errors.middleNameStartWithLetter'),
  })
  .matches(onlyCyrillic, {
    excludeEmptyString: true,
    message: i18n.t('COMMON:errors.useCyrillic'),
  });

const passportChangeReasons: OldFioDetails['passportChangeReason'][] = [
  'MARRIAGE',
  'DIVORCE',
  'OTHER',
];

export const previousNamesFormSchema = yup
  .object({
    oldFioDetails: yup
      .array()
      .of(
        yup
          .object({
            lastName: lastNameSchema,
            firstName: firstNameSchema,
            middleName: middleNameSchema,
            passportChangeReason: yup
              .mixed<OldFioDetails['passportChangeReason']>()
              .oneOf(passportChangeReasons, i18n.t('COMMON:errors.required'))
              .required(i18n.t('COMMON:errors.required')),
          })
          .required()
      )
      .required(i18n.t('COMMON:errors.required'))
      .min(RECORDS_PER_FORM_MIN, i18n.t('COMMON:errors.required'))
      .max(RECORDS_PER_FORM_MAX),
  })
  .required();
